import { useMemo, useState } from "react";
import Breadcrumb from "@/components/feature/Breadcrumb";
import GalleryCard from "@/components/feature/GalleryCard";
import EmptyState from "@/components/base/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";
import { galleries, galleryThemes } from "@/mocks/galleries";

export default function ImageCategoryPage() {
  usePageMeta({
    title: "图片分类 - 成人网",
    description:
      "成人网图片分类页，收录性感写真、艺术人像、光影质感、黑白胶片与复古胶片等主题图集，支持瀑布流浏览与大图预览。",
    keywords: "成人图片,图片分类,写真图集,艺术人像,黑白胶片,成人网",
  });

  const [theme, setTheme] = useState("全部");
  const [visible, setVisible] = useState(6);

  const filtered = useMemo(
    () => galleries.filter((gallery) => theme === "全部" || gallery.theme === theme),
    [theme],
  );

  const shown = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  return (
    <div className="container-page py-7">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "图片分类" }]} />

      <div className="mb-7 border-b border-background-200 pb-6">
        <span className="text-[11px] uppercase tracking-[0.28em] text-accent-500">Galleries</span>
        <h1 className="mt-2 font-heading text-2xl text-foreground-950 md:text-[32px]">图片分类</h1>
        <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-foreground-500">
          以光影与质感为主的写真图集，按主题分类浏览。点击任意封面即可进入大图模式，
          支持缩放与前后切换。
        </p>
      </div>

      <div className="mb-7 flex flex-wrap items-center gap-2">
        {galleryThemes.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => {
              setTheme(item);
              setVisible(6);
            }}
            className={`rounded-full px-3.5 py-1.5 text-[11.5px] transition-colors cursor-pointer ${
              theme === item
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-500 hover:text-foreground-900"
            }`}
          >
            {item}
          </button>
        ))}
        <span className="ml-auto text-[11px] text-foreground-500">
          共 {filtered.length} 组图集
        </span>
      </div>

      {shown.length > 0 ? (
        <>
          <div className="columns-1 gap-4 sm:columns-2 lg:columns-4">
            {shown.map((gallery) => (
              <div key={gallery.id} className="mb-4 break-inside-avoid">
                <GalleryCard gallery={gallery} />
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col items-center gap-3">
            {hasMore ? (
              <button
                type="button"
                onClick={() => setVisible((prev) => prev + 4)}
                className="flex items-center gap-2 rounded-md border border-background-300 px-6 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-add-line"></i>
                加载更多图集
              </button>
            ) : (
              <p className="text-[11px] text-foreground-500">已显示当前分类下的全部图集</p>
            )}
          </div>
        </>
      ) : (
        <EmptyState
          icon="ri-image-line"
          title="暂无符合条件的图集"
          description="这个主题下还没有收录作品，换一个主题看看，或者重置筛选浏览全部图集。"
          actionLabel="查看全部图集"
          onAction={() => {
            setTheme("全部");
            setVisible(6);
          }}
        />
      )}
    </div>
  );
}